// extracted by mini-css-extract-plugin
module.exports = {"list":"Title_list__29Qkx","am-list-content":"Title_am-list-content__224UL","am-list-extra":"Title_am-list-extra__Gnip3"};